<app-navbar></app-navbar>
<section class="builder-page py-4 py-xl-5 main-section-body-content">
    <div class="container">
        <div class="page-header mb-4">
            <h2>Assessment Builder</h2>
            <p>Create complete assessments by selecting categories and configuring subtype defaults.</p>
        </div>
        <div class="row">
            <div class="col-md-12">
                <mat-card class="mb-4 builder-card">
                    <mat-card-header>
                        <mat-card-title>Basic Details</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Assessment Name</mat-label>
                                    <input matInput placeholder="Assessment Title" [(ngModel)]="assessmentObject.assessmentTitle" required>
                                </mat-form-field>
                            </div>
                            <div class="col-md-6">
                                <mat-form-field class="w-100">
                                    <mat-label>Select Age Group</mat-label>
                                    <mat-select [(ngModel)]="assessmentObject.ageGroup" required>
                                        <mat-option *ngFor="let age of ageGroupList" [value]="age.value">
                                            {{age.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>

                <!-- Category Selection -->
                <mat-card class="mb-4 builder-card">
                    <mat-card-header>
                        <mat-card-title>Add Category</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="row">
                            <div class="col-12">
                                <mat-form-field class="w-100">
                                    <mat-label>Categories</mat-label>
                                    <mat-chip-grid #categoryChipGrid>
                                        <mat-chip-row *ngFor="let category of categoryListSet"
                                            [removable]="removable"
                                            (removed)="remove(category.typeId)">
                                            {{category.type}}
                                            <button matChipRemove>
                                                <mat-icon>cancel</mat-icon>
                                            </button>
                                        </mat-chip-row>
                                    </mat-chip-grid>
                                    <input placeholder="Search categories..."
                                        #categoryInput
                                        [formControl]="categoryListCtrl"
                                        [matAutocomplete]="auto"
                                        [matChipInputFor]="categoryChipGrid">
                                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                        <mat-option *ngFor="let category of filteredCategory | async" [value]="category">
                                            {{category.type}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>

                <!-- SubCategory Configuration -->
                <mat-card class="mb-4 builder-card" *ngIf="subCategoryListSet.length > 0">
                    <mat-card-header>
                        <mat-card-title>Set SubCategory</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="row">
                            <div class="col-12 mb-4">
                                <h4 class="config-title">Configure Categories</h4>
                            </div>
                            
                            <div *ngFor="let subCat of subCategoryListSet" class="w-100">
                                <mat-expansion-panel class="mb-3 config-panel">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            {{subCat.categoryId}}
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <!-- Selected SubTypes -->
                                    <div class="mb-3">
                                        <h4 class="mb-2">Selected SubTypes</h4>
                                        <mat-chip-grid>
                                            <mat-chip-row *ngFor="let subType of subCat.subCategoryList"
                                                [removable]="true"
                                                (removed)="removeSubCat(subType, subCat.categoryId)">
                                                {{subType.subType}}
                                                <button matChipRemove>
                                                    <mat-icon>cancel</mat-icon>
                                                </button>
                                            </mat-chip-row>
                                        </mat-chip-grid>
                                    </div>

                                    <!-- Configuration Controls -->
                                    <div class="row">
                                        <div class="col-md-6 col-xl-3 mb-3">
                                            <mat-form-field class="w-100">
                                                <mat-label>Question Timeline</mat-label>
                                                <mat-select [(ngModel)]="subCat.timeline">
                                                    <mat-option *ngFor="let time of times" [value]="time.value">
                                                        {{time.viewValue}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6 col-xl-3 mb-3">
                                            <mat-form-field class="w-100">
                                                <mat-label>Question Level</mat-label>
                                                <mat-select [(ngModel)]="subCat.defaultLevel">
                                                    <mat-option *ngFor="let lvl of levels" [value]="lvl.value">
                                                        {{lvl.viewValue}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6 col-xl-3 mb-3">
                                            <mat-form-field class="w-100">
                                                <mat-label>Default Questions</mat-label>
                                                <mat-select [(ngModel)]="subCat.defaultNumberOfQuestion">
                                                    <mat-option *ngFor="let qn of numberOfQuestion" [value]="qn.value">
                                                        {{qn.viewValue}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6 col-xl-3 mb-3">
                                            <mat-form-field class="w-100">
                                                <mat-label>Percentage Margin</mat-label>
                                                <mat-select [(ngModel)]="subCat.defaultPercentage">
                                                    <mat-option *ngFor="let percent of percentage" [value]="percent.value">
                                                        {{percent.viewValue}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-12">
                                            <mat-form-field class="w-100">
                                                <mat-label>Add SubType</mat-label>
                                                <mat-select (selectionChange)="onSubTypeSelection($event, subCat.categoryId)">
                                                    <mat-option *ngFor="let subType of typeArraySubList[subCat.categoryId]" [value]="subType.subTypeId">
                                                        {{subType.subType}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </mat-expansion-panel>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>

                <!-- Save Assessment -->
                <mat-card class="builder-card">
                    <mat-card-content class="text-center action-footer">
                        <div class="primary-actions">
                            <button mat-raised-button color="primary" (click)="createAssessment()" [disabled]="!isValidObj(assessmentObject)">
                                Save Assessment
                            </button>
                            <button mat-raised-button color="warn" (click)="deleteAssessment()">
                                Delete Assessment
                            </button>
                        </div>

                        <div class="state-actions">
                            <span class="state-summary">
                                Current state:
                                <strong [class.published]="isPublished">{{ assessmentObject.state }}</strong>
                            </span>
                            <button
                                mat-raised-button
                                color="accent"
                                (click)="toggleAssessmentState()"
                                [disabled]="!isValidObj(assessmentObject)"
                            >
                                {{ isPublished ? 'Move to Draft' : 'Publish Assessment' }}
                            </button>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>
